<script setup lang="ts">
import {Button} from '@/components/ui/button'
import {cn} from '@/lib/utils'
import {useRoute, useRouter} from 'vue-router'

const $router = useRouter()
const $route = useRoute()

const props = defineProps({
  organisation: {
    type: Object,
    required: true,
  }
});

</script>

<template>
  <nav class="flex space-x-2 lg:flex-col lg:space-x-0 lg:space-y-1">
    <Button
        @click="$router.push({path: `/${$route.params.organisationId}`})"
        variant="ghost"
        :class="cn(
        'w-full text-left justify-start',
        $route.path === `/${$route.params.organisationId}` && 'bg-muted hover:bg-muted',
      )">
      Apps
    </Button>

    <Button
        @click="$router.push({path: `/${$route.params.organisationId}/settings`})"
        variant="ghost"
        :class="cn(
        'w-full text-left justify-start',
        $route.path === `/${$route.params.organisationId}/settings` && 'bg-muted hover:bg-muted',
      )">
      Settings
    </Button>
        
  </nav>
</template>